import React from 'react';
import { Navigate } from 'react-router-dom';

interface RequireRecruiterProps {
  /** App-level auth flag (AppRoutes state, optionally OR'd with DEV bypass). */
  isAuthenticated: boolean;
  /** The authed user profile; null while the profile fetch is in flight. */
  user: { account_type?: string } | null;
  children: React.ReactNode;
}

/**
 * Route guard for /recruiter/* surfaces (spec section 10).
 *
 * - Unauthenticated visitors go to recruiter signup.
 * - Authenticated candidates go to their app home.
 * - While the profile is still loading, show the standard spinner rather
 *   than guessing (prevents a candidate flash-redirect for recruiters).
 */
export const RequireRecruiter: React.FC<RequireRecruiterProps> = ({
  isAuthenticated,
  user,
  children,
}) => {
  if (!isAuthenticated) {
    return <Navigate to="/signup?type=recruiter" replace />;
  }

  if (!user) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="mx-auto size-12 animate-spin rounded-full border-b-2 border-primary" />
      </div>
    );
  }

  if (user.account_type !== 'recruiter') {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
};
